<template>
  <section-collapseable>
    <record-next-contact
      :record="record"
      show-next-month
    ></record-next-contact>
  </section-collapseable>
</template>

<script>
export default {
  name: "LeadNextContact",
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        next_contact_at: null,
        current_status_id: null,
      };
    },
  }
};
</script>
